// PrePostLearning.tsx

import React, {useEffect} from 'react';
import {
  getLMSResultsData,
  getPageSection,
  getSearchForm
} from '@shared/services/service-handlers/PrivateService';
import {useAppContext} from '@context/AppContext';
import TabsComponent from '../../sub-modules-menu/tabsComponent/TabsComponent';
import {
  Card,
  CardContent,
  CircularProgress,
  IconButton,
  Typography
} from '@mui/material';
import {LoaderDiv} from '@components/card/CardComponentStyles';
import PreLearningActivities from './Prepostlearning/PreLearningActivities';
import {useLocation, useNavigate} from 'react-router-dom';
import ComputerIcon from '@mui/icons-material/Computer';
import FormConstants from '@shared/constants/FormConstants';
import {
  BASE_RECORD_ID,
  BASE_ROUTE,
  BASE_ROUTE_MODULE,
  BASE_UNIQUE_ID,
  LMS_IS_ADMIN,
  LMS_MODULE_ID,
  LMS_TYPE,
  MOVE_TO_TAB,
  PARAMS_KEY
} from 'src/routes/BaseRoute';
import PostLearningActivities from './Prepostlearning/PostLearningActivities';
import {OnlineContextProvider} from './ModulePageComponents/AdditionData/OnlineTestContext';
import EncryptUtils from 'src/utils/EncryptUtils';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import {enqueueSnackbar} from 'notistack';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {MoreVert} from '@mui/icons-material';
import {Box} from '@mui/system';
import Chip from 'src/pages/components/mui/chip';
import TabsComponentLMS from '../../sub-modules-menu/tabsComponent/TabsComponentLMS';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface PrePostLearningProps {
  uiFieldsdata: any;
}

const PrePostLearning = ({uiFieldsdata}: PrePostLearningProps) => {
  const navigate = useNavigate();
  const query = useQuery();
  const recordId = EncryptUtils.getDecryptedData(
    location?.search,
    BASE_RECORD_ID
  );
  const lmsisAdmin = EncryptUtils.getDecryptedData(
    location?.search,
    LMS_IS_ADMIN
  );
  const subsection = query.get('subsection');
  const lmstype = EncryptUtils.getDecryptedData(location?.search, LMS_TYPE);
  const section = query.get('section');
  const [tabData, setTabData] = React.useState<any>(uiFieldsdata?.searchForm);
  const [loader, setLoader] = React.useState(false);
  const [preLearnData, setPreLearnData] = React.useState<any>({});
  // const [postLearnData,setPostLearnData]=React.useState<any>({})
const [activeTab, setActiveTab] = React.useState<string>(
  subsection === 'pre_learning_activities' || subsection === 'post_learning_activities'
    ? subsection
    : 'pre_learning_activities'
);
  const [fieldsUIData, setFieldsUIData] = React.useState<any>(undefined);
  const {
    appState: {applicationName}
  } = useAppContext();
  function useQuery() {
    const {search} = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  const [uiFields, setUiFields] = React.useState<any>([]);

  function getSearchFormByName(data: {sub_sections: any[]}, tabName: any) {
    const tab = data?.sub_sections?.find(
      (section: {name: any}) => section.name === tabName
    );
    return tab || null;
  }

  const onRoleChange = async (item: any) => {
    const paramsKey = EncryptUtils.setEncryptedParams({
      [BASE_RECORD_ID]: recordId,
      [LMS_TYPE]: lmstype,
      [LMS_IS_ADMIN]: lmsisAdmin
    });
    navigate(
      `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}/new?${PARAMS_KEY}=${paramsKey}&section=${section}&subsection=${item}`,
      {
        state: {}
      }
    );
  };
  const onRoleChangePreview = async (data: any, type: string) => {
    //console.log('onRoleChange1', uniqueId, fileId, moduleId, onlineData);

    const paramsKey = EncryptUtils.setEncryptedParams({
      [BASE_RECORD_ID]: recordId,
      [LMS_TYPE]: lmstype,
      [LMS_IS_ADMIN]: lmsisAdmin,
      [MOVE_TO_TAB]:
        type === 'preLearnData'
          ? 'pre_learning_activities'
          : 'post_learning_activities',
      [BASE_UNIQUE_ID]: data?.id,
      [LMS_MODULE_ID]: data?.id
    });
    navigate(
      `/${BASE_ROUTE}/${BASE_ROUTE_MODULE}/${FormConstants.MODULE.COURSE_CATALOG}/OnlineTest?${PARAMS_KEY}=${paramsKey}`,
      {
        state: {}
      }
    );
  };
  const getPrePostData = async () => {
    try {
      // setOnlineLoader(true);
      // const res = await getSearchForm(
      //   applicationName,
      //   'settings',
      //   'Prelearning'
      // );
      // await setUiFields(res.searchForm);
      if (tabData) {
        const {sql_data} =
          tabData['sub_sections'][0]['searchForm']['create_sql'];
        const operations = 'PREPOSTDATA';
        const data: any = {
          sql_data: sql_data,
          data: {
            course_overview_id: recordId,
            overview_id: recordId,
            isAdmin: lmsisAdmin === 'True' ? true : false
          },
          operation: operations
        };
        //console.log('data', data);
        const encryptRequestData = EncryptUtils.encryptedData(data);
        const result = await getLMSResultsData(applicationName, 'LMS', {
          tk: encryptRequestData
        });
        // await setIsEnabled(result.data[0]?.isPreLearningTestEnabled);
        // await setIsMandatory(result.data[0]?.isPreLearningTestMandatory);
        // console.log(
        //   'result.data[0]',
        //   result.data[0],
        //   result.data[0].inserted_id
        // );
        const transformedResults = result.data.map((item: any) => {
          return {
            ...item,
            // Parse JSON fields or set them to empty arrays if they are null
            ipRestrictions: item.ipRestrictions
              ? JSON.parse(item.ipRestrictions)
              : null,
            PostLearnipRestrictions: item.PostLearnipRestrictions
              ? JSON.parse(item.PostLearnipRestrictions)
              : null,
            PreLearnipRestrictions: item.PreLearnipRestrictions
              ? JSON.parse(item.PreLearnipRestrictions)
              : null,
            postlearning: item.postlearning
              ? [JSON.parse(item.postlearning)]
              : [],
            prelearning: item.prelearning ? [JSON.parse(item.prelearning)] : []
            // Add any additional transformations here if needed
          };
        });
        setPreLearnData(transformedResults[0]);
        // setOnlineData(transformedResults[0]);
        // const datas: any = {
        //   sql_data: sql_data,
        //   data: {
        //     course_overview_id: result.data[0].inserted_id || recordId,
        //     overview_id: result.data[0].inserted_id
        //   },
        //   operation: 'QUESTIONSEARCH'
        // };
        // const encryptRequestDatas = EncryptUtils.encryptedData(datas);
        // const results = await getLMSResultsData(applicationName, 'LMS', {
        //   tk: encryptRequestDatas
        // });
        // const transformedResult = results.data.map((item: any) => {
        //   return {
        //     ...item,
        //     // Parse JSON fields or set them to empty arrays if they are null
        //     choices: item.choices ? JSON.parse(item.choices) : null,
        //     correctMatches: item.correctMatches
        //       ? JSON.parse(item.correctMatches)
        //       : null,
        //     additionalChoices: item.additionalChoices
        //       ? JSON.parse(item.additionalChoices)
        //       : null,
        //     descriptive_enforce_word_limit: item.descriptive_enforce_word_limit
        //       ? JSON.parse(item.descriptive_enforce_word_limit)
        //           .descriptive_enforce_word_limit
        //       : null,
        //     // Parse the descriptive_enforce_word_limit_length JSON or set it to null
        //     descriptive_enforce_word_limit_length:
        //       item.descriptive_enforce_word_limit_length
        //         ? JSON.parse(item.descriptive_enforce_word_limit_length)
        //             .descriptive_enforce_word_limit_length
        //         : null,
        //     TrueFalse: item.TrueFalse
        //       ? JSON.parse(item.TrueFalse).TrueFalse
        //       : null
        //     // Add any additional transformations here if needed
        //   };
        // });
        // console.log('transformedResult', transformedResult);
        // await setQuestionData(transformedResult);
        // if (result.data[0].assignment_submission_type_id) {
        //   setSubmissionType(result.data[0].assignment_submission_type_id);
        //   setValue(
        //     'SubmissionType',
        //     result.data[0].assignment_submission_type_id
        //   );
        // }

        // setOnlineLoader(false);
      }

      // setOnlineLoader(false);
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      // setOnlineLoader(false);
    }
  };

  useEffect(() => {
    // Fetch data from the API
    const fetchData = async () => {
      setLoader(true);
      if (uiFieldsdata === null || uiFieldsdata === undefined) {
        const res = await getSearchForm(
          applicationName,
          'course_management_fetch'
        );
        const value = getSearchFormByName(res.searchForm, activeTab);
        setFieldsUIData(value);
        setTabData(res.searchForm);
      } else {
        const value = getSearchFormByName(uiFieldsdata.searchForm, activeTab);
        setFieldsUIData(value);
        setTabData(uiFieldsdata.searchForm);
      }
      if (lmsisAdmin === 'False') {
        await getPrePostData();
      }
      setLoader(false);
      if (activeTab === 'pre_learning_activities') {
        onRoleChange(activeTab);
      }
    };
    fetchData();
  }, []);

  const handleActiveTabChange = async (tabName: string) => {
    const activeTabDetails = tabData?.sub_sections?.find(
      (section: any) => section.name === tabName
    );
    // const value = await getSearchFormByName(uiFieldsdata?.searchForm, tabName);
    setFieldsUIData(activeTabDetails);
    setActiveTab(tabName);
    onRoleChange(tabName);
  };
  return (
    <div>
      {!loader ? (
        lmsisAdmin === 'True' ? (
          <>
            <TabsComponentLMS
              sectionUIData={tabData}
              sectionRowsData={[]}
              module="prepostlearning"
              handleActiveTabChange={handleActiveTabChange}
            />

            {activeTab === 'pre_learning_activities' &&
              fieldsUIData !== undefined && (
                <OnlineContextProvider>
                  <PreLearningActivities uiFieldsData={fieldsUIData} />
                </OnlineContextProvider>
              )}
            {activeTab === 'post_learning_activities' &&
              fieldsUIData !== undefined && (
                <OnlineContextProvider>
                  <PostLearningActivities uiFieldsData={fieldsUIData} />
                </OnlineContextProvider>
              )}
          </>
        ) : (
          <>
            {preLearnData &&
              preLearnData?.isPreLearningTestEnabled &&
              preLearnData?.prelearning?.length > 0 && (
                <Box>
                  <Typography
                    variant="h5"
                    p={2}
                    sx={{fontWeight: 'bold', color: '#000'}}>
                    Pre Learning Activities
                  </Typography>
                  <Box sx={{mx: 2, p: 2}}>
                    <Card
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        p: 2,
                        // boxShadow:
                        //   isEnabled &&
                        //   '8px 10px 9px 0px rgba(145, 158, 171, 0.2), 0px 2px 2px 0px rgba(145, 158, 171, 0.14), 0px 1px 5px 0px rgba(145, 158, 171, 0.12)',
                        borderRadius: 2,
                        cursor: 'pointer'
                        // bgcolor: isEnabled ? 'white' : '#d9d9d9'
                      }}>
                      {/* Left Icon Section */}
                      <Box
                        sx={{
                          // bgcolor: isEnabled ? '#FFF7DD' : '#f1f1f1',
                          p: 2,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderRadius: 2,
                          mr: 2,
                          width: 64,
                          height: 64
                        }}>
                        <ComputerIcon sx={{fontSize: 32, color: '#FBC02D'}} />
                      </Box>

                      {/* Content Section */}
                      <CardContent
                        onClick={() => {
                          onRoleChangePreview(
                            preLearnData?.prelearning[0],
                            'preLearnData'
                          );
                        }}
                        sx={{
                          flexGrow: 1,
                          p: 0,
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center'
                          // cursor: isEnabled ? 'pointer' : 'cursor'
                        }}>
                        <Typography variant="h6" sx={{fontWeight: 'bold'}}>
                          {preLearnData.prelearning[0].name}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Questions:{' '}
                          {preLearnData.prelearning[0].QuestionsCount} • Marks:{' '}
                          {preLearnData.prelearning[0].totalMarks} • Duration:
                          {preLearnData?.prelearning[0]
                            ?.assessment_time_limit_type_id === 1
                            ? preLearnData?.prelearning[0]
                                ?.overallTime_in_minutes
                            : preLearnData?.prelearning[0]
                                  ?.assessment_time_limit_type_id === 2
                              ? preLearnData.prelearning[0]
                                  ?.time_per_question_in_minutes *
                                preLearnData.prelearning[0]?.QuestionsCount
                              : 'No Time Limit'}
                        </Typography>
                      </CardContent>

                      {/* Right Actions Section */}
                    </Card>
                  </Box>
                </Box>
              )}
            {preLearnData &&
              preLearnData?.isPostLearningTestEnabled &&
              preLearnData?.postlearning?.length > 0 && (
                <Box>
                  <Typography
                    variant="h5"
                    p={2}
                    sx={{fontWeight: 'bold', color: '#000'}}>
                    Post Learning Activities
                  </Typography>
                  <Box sx={{mx: 2, p: 2}}>
                    <Card
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        p: 2,
                        // boxShadow:
                        //   isEnabled &&
                        //   '8px 10px 9px 0px rgba(145, 158, 171, 0.2), 0px 2px 2px 0px rgba(145, 158, 171, 0.14), 0px 1px 5px 0px rgba(145, 158, 171, 0.12)',
                        borderRadius: 2,
                        cursor: 'pointer'
                        // bgcolor: isEnabled ? 'white' : '#d9d9d9'
                      }}>
                      {/* Left Icon Section */}
                      <Box
                        sx={{
                          // bgcolor: isEnabled ? '#FFF7DD' : '#f1f1f1',
                          p: 2,
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          borderRadius: 2,
                          mr: 2,
                          width: 64,
                          height: 64
                        }}>
                        <ComputerIcon sx={{fontSize: 32, color: '#FBC02D'}} />
                      </Box>

                      {/* Content Section */}
                      <CardContent
                        onClick={() => {
                          onRoleChangePreview(
                            preLearnData?.postlearning[0],
                            'postLearnData'
                          );
                        }}
                        sx={{
                          flexGrow: 1,
                          p: 0,
                          display: 'flex',
                          flexDirection: 'column',
                          justifyContent: 'center'
                          // cursor: isEnabled ? 'pointer' : 'cursor'
                        }}>
                        <Typography variant="h6" sx={{fontWeight: 'bold'}}>
                          {preLearnData.postlearning[0].name}
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                          Questions:{' '}
                          {preLearnData.postlearning[0].QuestionsCount} • Marks:{' '}
                          {preLearnData.postlearning[0].totalMarks} • Duration:
                          {preLearnData?.postlearning[0]
                            ?.assessment_time_limit_type_id === 1
                            ? preLearnData?.postlearning[0]
                                ?.overallTime_in_minutes
                            : preLearnData?.postlearning[0]
                                  ?.assessment_time_limit_type_id === 2
                              ? preLearnData.postlearning[0]
                                  ?.time_per_question_in_minutes *
                                preLearnData.postlearning[0]?.QuestionsCount
                              : 'No Time Limit'}
                        </Typography>
                      </CardContent>

                      {/* Right Actions Section */}
                    </Card>
                  </Box>
                </Box>
              )}
            {!preLearnData.isPreLearningTestEnabled &&
              !preLearnData.isPostLearningTestEnabled && (
                <Box
                  sx={{
                    mx: 2,
                    p: 2,
                    minHeight: '50vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#f1f1f1'
                  }}>
                  <Typography variant="h6" sx={{fontWeight: 'bold'}}>
                    Pre and Post Learning Activities are not enabled for this
                    course.
                  </Typography>
                </Box>
              )}
          </>
        )
      ) : (
        <LoaderDiv>
          <CircularProgress />
        </LoaderDiv>
      )}
    </div>
  );
};

export default PrePostLearning;
